import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import sortIcon from "../../../assets/icons/sort.svg";
import filterIcon from "../../../assets/icons/filter.svg";
import { MdCircle, MdOutlineCircle } from "react-icons/md";
import FilterModal from "./FilterModal";
import { Input, message, Spin, Button } from "antd";
import ErrorLogout from "../../../helpers/ErrorLogout";
import Pagination from "../Pagination";
import ProductCard from "./ProductCard";
import { IoClose } from "react-icons/io5";
import { getAllBid } from "../../../api/CommonRequest";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../store/authStore";

const { Search } = Input;

const BidList = () => {
  const { userType } = useAuthStore();
  const [activeTab, setActiveTab] = useState(""); // Update initial state to 'all'
  const [tabFilter, setTabFilter] = useState(""); // Update initial state to 'all'
  // ...
  // const tabs = ['All', 'Live', 'On Hold', 'Cancelled'];
  const tabs = [
    { label: "All", value: "" },
    { label: "Live", value: "live" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Approved", value: "approved" },
    { label: "Expired", value: "expired" },
    { label: "Closed", value: "closed" },
    { label: "Ready to Sell", value: "sell" },
    { label: "Sold", value: "sold" },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [sortBy, setSortBy] = useState({
    key: "1",
    label: "Recently added",
    value: "createdDate:desc",

    icon: <MdCircle size={20} />,
  });
  const [searchValue, setSearchValue] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [type, setType] = useState(null);
  const [bidRange, setBidRange] = useState([1000, 10000000]);
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [bids, setBids] = useState([]);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);
  const [showSingleProduct, setShowSingleProduct] = useState(false);
  const [bidID, setBidID] = useState("");

  const navigate = useNavigate();

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Function to handle button clicks

  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  // ------ SORT BY ITEMS--------
  const sortItems = [
    {
      key: "1",
      label: "Recently added",
      value: "createdDate:desc",
      icon:
        sortBy.key === "1" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "2",
      label: "Price-High to Low",
      value: "bidLivePrice:desc",
      icon:
        sortBy.key === "2" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "3",
      label: "Price-Low to High",
      value: "bidLivePrice:asc",
      icon:
        sortBy.key === "3" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "4",
      label: "Most active",
      value: "bidCount:desc",
      icon:
        sortBy.key === "4" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
  ];

  const handleSort = (item) => {
    setSortBy(item);
  };
  const handleRemoveCategory = (categoryToRemove) => {
    setSubCategory(subCategory.filter((filter) => filter !== categoryToRemove));
  };

  const handleClearFilter = () => {
    setSubCategory([]);
    setType("All");
    setBidRange([1000, 100000]);
  };
  const onSearch = (value) => setSearchTerm(value);

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllBid({
          q: searchTerm,
          subCategory: subCategory.map((item) => item._id),
          bidRange: bidRange,
          type: type === "Public" ? true : type === "Group" ? false : null,
          sort: sortBy.value,
          page: currentPage,
          limit: limit,
          bidStatus: tabFilter,
        });

        if (data?.success) {
          setBids(data?.bidList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false); // Ensure loader is turned off

        // Default error message
        let errorMessage = "An unexpected error occurred.";

        // Check if the error has a response and its data
        if (error?.response) {
          // If the error has a response, access status and message safely
          const { status, data } = error.response;

          // Default to the message from the response if it exists, else use a generic message
          errorMessage = data?.message || errorMessage;

          // Handle specific status codes
          if (status === 401) {
            ErrorLogout(error); // Handle 401 Unauthorized, e.g., logout the user
          } else if (status === 403) {
            errorMessage =
              "You do not have permission to access this resource.";
          } else if (status >= 500) {
            errorMessage = "Server error, please try again later.";
          }
        } else if (error?.message) {
          // If the error doesn't have a response, use its message
          errorMessage = error.message;
        }

        // Show error to the user
        message.error(errorMessage);

        // Log the error for debugging
        console.error("API Error:", error);
      }
    };
    bidsCall();
  }, [
    searchTerm,
    sortBy,
    limit,
    currentPage,
    subCategory,
    type,
    bidRange,
    tabFilter,
    trigger,
  ]);

  return (
    <>
      <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
        <div>
          <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white  ">
            {/* <div className="mb-4 flex items-center text-sm md:text-base">
            <Link to="./">   <GoHome className="text-[#C7C7C7] text-[20px] md:text-[24px]" /></Link>
            <span className="ml-2 text-[#313131] text-base md:text-lg font-medium">
              / Bids
            </span>
          </div> */}
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-4 mt-2">
              <div className="w-full lg:w-auto overflow-x-auto scrollbar-hide py-1">
                <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white">
                  {tabs.map((tab) => (
                    <button
                      key={tab.value}
                      className={`h-10 px-5 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                        ${activeTab === tab.value
                          ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                          : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                        }`}
                      onClick={() => {
                        setActiveTab(tab.value);
                        setTabFilter(tab.value);
                        setCurrentPage(1);
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Spin spinning={loader}>
            <div className="pt-[5px]  space-y-10">
              {/* -------------- FILTER------------ */}

              <div className="flex flex-col xl:flex-row justify-between items-center gap-4 mb-6">
                <div className="flex flex-col md:flex-row items-center gap-3 w-full xl:w-auto">
                  <div className="w-full md:w-auto">
                    <Search
                      defaultValue={searchValue}
                      placeholder="Search Bids, Category etc..."
                      allowClear
                      onSearch={onSearch}
                      size="large"
                      className="w-full md:w-80 custom-search"
                    />
                  </div>
                  <div className="flex items-center gap-3 w-full md:w-auto">
                    <div className="relative inline-block flex-1 md:flex-none md:w-52">
                      <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="w-full bg-white border border-[#A3BBFF] rounded-lg px-4 h-10 flex items-center justify-between text-[#1955EB] font-medium hover:border-[#1955EB] transition-colors shadow-sm"
                      >
                        <div className="flex items-center gap-2">
                          <img src={sortIcon} alt="sort" className="w-5" />
                          <span className="text-[15px]">Sort By</span>
                        </div>
                        <FaChevronDown className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                      </button>
                      {isOpen && (
                        <ul className="absolute left-0 mt-2 w-full bg-white border border-gray-100 shadow-2xl rounded-xl z-[100] overflow-hidden py-1">
                          {sortItems.map((item) => (
                            <li
                              key={item.key}
                              onClick={() => {
                                handleSort(item);
                                setIsOpen(false);
                              }}
                              className="flex items-center gap-3 px-4 py-3 hover:bg-blue-50 cursor-pointer group transition-colors"
                            >
                              <span className="text-blue-500 group-hover:scale-110 transition-transform">{item.icon}</span>
                              <span className="text-sm font-semibold text-gray-700 group-hover:text-[#1955EB]">
                                {item.label}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                    <button
                      className="flex-1 md:flex-none flex items-center justify-center gap-2 bg-white border border-[#A3BBFF] rounded-lg px-6 h-10 text-[#1955EB] font-medium hover:border-[#1955EB] hover:bg-blue-50 transition-all shadow-sm"
                      onClick={() => setIsModalVisible(true)}
                    >
                      <img src={filterIcon} alt="filter" className="w-5" />
                      <span className="text-[15px]">Filter</span>
                    </button>
                  </div>

                  <div className="flex flex-wrap gap-2 w-full md:w-auto justify-end">
                    {subCategory.map((filter, index) => (
                      <div
                        key={index}
                        className="flex items-center bg-blue-50 text-[#1955EB] px-3 py-1.5 rounded-lg border border-blue-100 text-sm font-semibold shadow-sm animate-in fade-in zoom-in duration-200"
                      >
                        <span>{filter.name}</span>
                        <button
                          className="ml-2 hover:text-red-500 transition-colors"
                          onClick={() => handleRemoveCategory(filter)}
                        >
                          <IoClose size={18} />
                        </button>
                      </div>
                    ))}
                    {subCategory.length > 0 && (
                      <button
                        className="text-[#1955EB] text-sm font-bold hover:underline px-2"
                        onClick={() => handleClearFilter()}
                      >
                        Clear All
                      </button>
                    )}
                  </div>
                </div>

                {userType === "admin" && (
                  <div>
                    <button onClick={() => navigate("/create-bid")} className="bg-[#1955EB] text-white px-4 py-2 rounded-md">Create Bid</button>
                  </div>

                )}
              </div>

              {/* {activeTab === 'All' && ( */}
              <div className="flex flex-col  overflow-auto  space-y-4 md:space-y-10">
                {bids.map((item) => (
                  <ProductCard
                    item={item}
                    trigger={trigger}
                    setTrigger={setTrigger}
                    setShowSingleProduct={setShowSingleProduct}
                    setBidID={setBidID}
                  />
                ))}
              </div>
              {/* )} */}
              {/* Pagination Component */}
            </div>
            <div className=" mt-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>
            <FilterModal
              isVisible={isModalVisible}
              onClose={() => setIsModalVisible(false)}
              setSubCategory={setSubCategory}
              subCategory={subCategory}
              type={type}
              setType={setType}
              bidRange={bidRange}
              setBidRange={setBidRange}
            />
          </Spin>
        </div>
      </div>
    </>
  );
};

export default BidList;
